"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.object.entries.js");

var _vue = _interopRequireDefault(require("vue"));

var _shipOperationsDepartures = _interopRequireDefault(require("./ship-operations-departures.vue"));

(function (el) {
  var fields = el.dataset;
  var fields_map = Object.keys(fields).filter(function (key) {
    return key != 'url';
  }).map(function (key) {
    return (0, _defineProperty2["default"])({}, key, {
      label: fields[key]
    });
  });
  var url_endpoint = Object.entries(fields).filter(function (item) {
    return item[0] == 'url';
  });
  var limit = Object.entries(fields).filter(function (item) {
    return item[0] == 'limit';
  });
  var type = Object.entries(fields).filter(function (item) {
    return item[0] == 'type';
  });
  new _vue["default"]({
    el: '#ShipOperationsDepartures',
    render: function render(h) {
      return h(_shipOperationsDepartures["default"]);
    },
    data: {
      fields: fields_map,
      url: url_endpoint[0][1],
      limit: limit[0][1],
      type: type[0][1]
    }
  });
})(document.getElementById('ShipOperationsDepartures'));